import * as React from 'react'

const SvgWarningAltIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 13.75a.937.937 0 100 1.875.937.937 0 000-1.875zm-.625-6.875h1.25V12.5h-1.25V6.875zm8.75 11.25H1.875a.625.625 0 01-.556-.913L9.444 1.587a.625.625 0 011.112 0l8.125 15.625a.625.625 0 01-.556.913zm-15.219-1.25h14.188L10 3.231 2.906 16.875z"
      fill="#163250"
    />
  </svg>
)

export default SvgWarningAltIcon
